import Login from "pages/Auth/Login";
import Page404 from "pages/Page404";
import Home from "pages/Home/Home";
import Organizations from "pages/Organizations/Organizations";
import Organization from "pages/Organizations/Organization";
import OrganizationDetail from "pages/Organizations/OrganizationDetail";
import Admins from "pages/Admins/Admins";
import Admin from "pages/Admins/Admin";
import MyAccount from "pages/Admins/MyAccount";
import Support from "pages/Support/Support";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";
import AppointmentTypes from "pages/AppointmentTypes/AppointmentTypes";
import AppointmentType from "pages/AppointmentTypes/AppointmentType";
import Events from "pages/Events/Events";
import Documents from "pages/Documents/Documents";
import DocumentDetail from "pages/Documents/DocumentDetail";
import DocumentEdit from "pages/Documents/DocumentEdit";
import Products from "pages/Products/Products";
import Product from "pages/Products/Product";
import SmartReports from "pages/SmartReports/SmartReports";
import Tags from "pages/Tags/Tags";
import EventTypes from "pages/EventTypes/EventTypes";
import ContactRequests from "pages/ContactRequests/ContactRequests";
import ContactRequestDetail from "pages/ContactRequests/ContactRequestDetail";
import FAQ from "pages/FAQ/FAQ";
import News from "pages/News/News";
import NewsPage from "pages/News/NewsPage";
import Plans from "pages/Plans/Plans";

const admins = ["SuperAdmin", "Admin"];
const all = ["SuperAdmin", "Admin", "Manager"];

const routes = [
  // Content — all roles
  { path: "/events", roles: all, Component: Events },
  { path: "/documents", roles: all, Component: Documents },
  { path: "/documents/edit/:id", roles: all, Component: DocumentEdit },
  { path: "/documents/:id", roles: all, Component: DocumentDetail },
  { path: "/products", roles: all, Component: Products },
  { path: "/products/add", roles: all, Component: Product },
  { path: "/products/edit/:id", roles: all, Component: Product },
  { path: "/smart-reports", roles: all, Component: SmartReports },

  // Community — all roles
  { path: "/contact-requests", roles: all, Component: ContactRequests },
  {
    path: "/contact-requests/:id",
    roles: all,
    Component: ContactRequestDetail,
  },
  { path: "/faq", roles: all, Component: FAQ },
  { path: "/news", roles: all, Component: News },
  { path: "/news/add", roles: all, Component: NewsPage },
  { path: "/news/edit/:id", roles: all, Component: NewsPage },

  // Admin only
  { path: "/event-types", roles: admins, Component: EventTypes },
  { path: "/tags", roles: admins, Component: Tags },
  { path: "/plans", roles: admins, Component: Plans },
  { path: "/administrators", roles: admins, Component: Admins },
  { path: "/administrators/add", roles: admins, Component: Admin },
  { path: "/administrators/edit/:id", roles: admins, Component: Admin },

  // Appointment types (legacy)
  { path: "/appointment-types", roles: admins, Component: AppointmentTypes },
  { path: "/appointment-types/add", roles: admins, Component: AppointmentType },
  {
    path: "/appointment-types/edit/:id",
    roles: admins,
    Component: AppointmentType,
  },

  // Account
  { path: "/my-account", roles: all, Component: MyAccount },
  { path: "/organizations", roles: admins, Component: Organizations },
  {
    path: "/organizations/:id",
    roles: admins,
    Component: OrganizationDetail,
  },
  {
    path: "/organizations/add",
    roles: admins,
    Component: Organization,
  },
  {
    path: "/organizations/edit/:id",
    roles: admins,
    Component: Organization,
  },

  // Help
  { path: "/support", roles: "all", Component: Support },

  { path: "/", roles: "all", Component: Home },
  { path: "*", roles: "all", exact: false, Component: Page404 },
];

export const loginRoutes = [
  { path: "/login", roles: "all", Component: Login },
  { path: "/forgot-password", roles: "all", Component: ForgotPassword },
  { path: "/reset-password", roles: "all", Component: ResetPassword },
  { path: "/", roles: "all", Component: Login },
  { path: "*", roles: "all", exact: false, Component: Login },
];

export default routes;
